import type { FaireProductEntity } from "../../entity_types/product";

export const p_as392eppab: FaireProductEntity = {
  token: "p_as392eppab",
  type: "product",
  name: "Mahjong LINE ID Stickers - 2026 edition - LARGE size",
  brandToken: "b_p3ekksgz4k",
  brandName: "Mama Bear Mahjong",
  imageUrl:
    "https://cdn.faire.com/fastly/5cf6e4d385ed3f1990d01a593e430366515acca46d40fbfdf8f67574432e6538.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b8ec161a10663309d5023f53a250230fdfc4ebfd57dc68ac7b4d0b26af1a5389.jpeg",
    "https://cdn.faire.com/fastly/7f6613176e1ef490ce9e747538e624d95d8a9b695751dd400b6307657ea068e6.jpeg",
    "https://cdn.faire.com/fastly/bb1863d4c2ac7236746facda249062542dc2cd5f1f79542f656d884d90b8a83b.jpeg",
    "https://cdn.faire.com/fastly/ac3cf645969fc171eb82be9438439d5b8fbafa6789ba7b2c17e656942fd90e1a.jpeg",
    "https://cdn.faire.com/fastly/a16aa3d3ad13ef84b7c0e8aa3462bb2be99f0edf02658fa5f723615502f85973.jpeg",
  ],
  priceDollars: 3.25,
  description:
    "Clean, stylish, and made to elevate your game—our line ID stickers are designed with both form and function in mind. Whether you’re learning the card or playing at a competitive level, these thoughtfully crafted stickers help you quickly identify patterns, stay organized, and play with confidence.\n\nEach set is printed on high-quality, durable material with a smooth, matte finish that blends seamlessly into your Mahjong card—no glare, no distraction. The designs are clear, intuitive, and easy to read at a glance, making them perfect for beginners and seasoned players alike.\n\nCreated with a refined, minimalist aesthetic, our line ID stickers don’t just help you play better—they look beautiful doing it.\n\nSimplify your strategy. Elevate your table. Play smarter.\n\nFits the LARGE 2026 National Mah Jongg League Card",
  tags: [],
  msrpDollars: 5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:28.717Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
